import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('install_authentication_app_to_log_in'),
    buttonNext: defineMessage('next'),
    buttonPrev: defineMessage('back'),
};
